import { render, staticRenderFns } from "./bi-header.vue?vue&type=template&id=b0b54e3e&scoped=true&"
import script from "./bi-header.vue?vue&type=script&lang=js&"
export * from "./bi-header.vue?vue&type=script&lang=js&"
import style0 from "./bi-header.vue?vue&type=style&index=0&id=b0b54e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b54e3e",
  null
  
)

export default component.exports